(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var mount = document.getElementById("eta-collector-signups");
    if (!mount) return;

    var artists = JSON.parse(mount.getAttribute("data-artists") || "[]");
    if (!artists.length) return;

    // Normalize URLs (menu links may be relative)
    artists = artists.map(function (a) {
      var collectionUrl = a.collectionUrl || "";
      if (collectionUrl && !collectionUrl.startsWith("http")) {
        collectionUrl = window.location.origin + collectionUrl;
      }
      return {
        name: a.name || "",
        collectionUrl: collectionUrl,
        imgSrc: a.imgSrc || "",
        flodeskUrl: a.flodeskUrl || ""
      };
    });

    /* ================= GRID ================= */

    var grid = document.createElement("div");
    grid.className = "eta-grid";

    artists.forEach(function (artist) {
      var card = document.createElement("div");
      card.className = "eta-card";

      // Image links to collection
      if (artist.imgSrc) {
        var imgLink = document.createElement("a");
        imgLink.href = artist.collectionUrl;

        var img = document.createElement("img");
        img.src = artist.imgSrc;
        img.alt = artist.name;
        img.loading = "lazy";

        imgLink.appendChild(img);
        card.appendChild(imgLink);
      }

      var name = document.createElement("p");
      name.className = "eta-name";
      name.textContent = artist.name;
      card.appendChild(name);

      var actions = document.createElement("div");
      actions.className = "eta-actions";

      var updates = document.createElement("button");
      updates.className = "eta-btn eta-btn--primary";
      updates.type = "button";
      updates.textContent = "Get updates";
      updates.addEventListener("click", function () {
        openModalWithArtist(artist);
      });

      actions.appendChild(updates);
      card.appendChild(actions);

      grid.appendChild(card);
    });

    mount.innerHTML = "";
    mount.appendChild(grid);

    /* ================= MODAL ================= */

    var modal = document.createElement("div");
    modal.className = "eta-modal";
    modal.setAttribute("aria-hidden", "true");

    modal.innerHTML = `
      <div class="eta-modal__panel" role="dialog" aria-modal="true" aria-labelledby="eta-modal-title">
        <div class="eta-modal__header">
          <p class="eta-modal__title" id="eta-modal-title"></p>
          <button class="eta-modal__close" type="button">Close</button>
        </div>

        <div class="eta-modal__toolbar">
          <button class="eta-btn" type="button" id="eta-add-another">Add another artist</button>
          <button class="eta-btn" type="button" id="eta-back-to-form" style="display:none;">Back to form</button>
        </div>

        <div id="eta-form-view">
          <div id="eta-modal-body"></div>
          <p style="margin-top:12px;font-size:14px;opacity:.85;">
            If the signup doesn’t load, you can
            <a href="#" id="eta-fallback-link" target="_blank" rel="noopener">open it in a new tab</a>.
          </p>
        </div>

        <div class="eta-picker" id="eta-picker" aria-hidden="true">
          <input class="eta-picker__search" id="eta-picker-search" type="search" placeholder="Search artists…" autocomplete="off">
          <div class="eta-picker__list" id="eta-picker-list"></div>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    var titleEl = modal.querySelector("#eta-modal-title");
    var bodyEl = modal.querySelector("#eta-modal-body");
    var closeBtn = modal.querySelector(".eta-modal__close");
    var fallbackLink = modal.querySelector("#eta-fallback-link");

    var addAnotherBtn = modal.querySelector("#eta-add-another");
    var backBtn = modal.querySelector("#eta-back-to-form");

    var formView = modal.querySelector("#eta-form-view");
    var picker = modal.querySelector("#eta-picker");
    var pickerSearch = modal.querySelector("#eta-picker-search");
    var pickerList = modal.querySelector("#eta-picker-list");

    var currentArtist = null;

    function openModal() {
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
    }

    function closeModal() {
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      bodyEl.innerHTML = "";
      fallbackLink.href = "#";
      currentArtist = null;
      showFormView();
    }

    function showPickerView() {
      picker.setAttribute("aria-hidden", "false");
      formView.style.display = "none";
      backBtn.style.display = "";
      addAnotherBtn.style.display = "none";

      pickerSearch.value = "";
      renderPickerList("");
      pickerSearch.focus();
    }

    function showFormView() {
      picker.setAttribute("aria-hidden", "true");
      formView.style.display = "";
      backBtn.style.display = "none";
      addAnotherBtn.style.display = "";
    }

    function openModalWithArtist(artist) {
      currentArtist = artist;

      titleEl.textContent = "Get " + artist.name + " updates";
      bodyEl.innerHTML = "<p>Loading signup…</p>";

      openModal();
      showFormView();

      if (!artist.flodeskUrl) {
        bodyEl.innerHTML = "<p>Signup unavailable.</p>";
        fallbackLink.href = artist.collectionUrl || "#";
        return;
      }

      fallbackLink.href = artist.flodeskUrl;

      bodyEl.innerHTML = "";
      var iframe = document.createElement("iframe");
      iframe.className = "eta-iframe";
      iframe.src = artist.flodeskUrl;
      iframe.title = "Signup form for " + artist.name;
      iframe.loading = "lazy";
      bodyEl.appendChild(iframe);
    }

    function renderPickerList(filterText) {
      var q = (filterText || "").toLowerCase().trim();
      pickerList.innerHTML = "";

      var items = artists.filter(function (a) {
        return !q || (a.name || "").toLowerCase().includes(q);
      });

      items.forEach(function (artist) {
        var row = document.createElement("div");
        row.className = "eta-picker__item";

        if (artist.imgSrc) {
          var img = document.createElement("img");
          img.src = artist.imgSrc;
          img.alt = artist.name;
          img.loading = "lazy";
          row.appendChild(img);
        }

        var name = document.createElement("p");
        name.className = "eta-picker__name";
        name.textContent = artist.name;
        row.appendChild(name);

        var actions = document.createElement("div");
        actions.className = "eta-picker__actions";

        var choose = document.createElement("button");
        choose.type = "button";
        choose.className = "eta-btn eta-btn--primary";
        choose.textContent = "Get updates";
        choose.addEventListener("click", function () {
          showFormView();
          openModalWithArtist(artist);
        });

        actions.appendChild(choose);
        row.appendChild(actions);

        pickerList.appendChild(row);
      });

      if (!items.length) {
        pickerList.innerHTML = '<p style="margin:0; padding:10px; opacity:.75;">No matches.</p>';
      }
    }

    // Events
    closeBtn.addEventListener("click", closeModal);

    modal.addEventListener("click", function (e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.getAttribute("aria-hidden") === "false") {
        closeModal();
      }
    });

    addAnotherBtn.addEventListener("click", function () {
      showPickerView();
    });

    backBtn.addEventListener("click", function () {
      showFormView();
    });

    pickerSearch.addEventListener("input", function () {
      renderPickerList(pickerSearch.value);
    });
  });
})();
